import { createContext, useState } from "react";

export const allContext = createContext();

export const AllContextProvider = ({ children }) => {

    const [state, setState] = useState("");
    const [pageLoading, setPageLoading] = useState(false);
    const [dataUpdate, setDataUpdate] = useState(false);
    const [fromTime, setfromTime] = useState("");
    const [toTime, settoTime] = useState("");
    const [employeeID, setemployeeID] = useState("");
    const [type, setType] = useState("");
    const [reportSearch, setReportSearch] = useState(false);
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);

    return (
        <allContext.Provider
            value={{
                state,
                setState,
                pageLoading,
                setPageLoading,
                dataUpdate,
                setDataUpdate,
                fromTime, 
                setfromTime,
                toTime, 
                settoTime,
                employeeID, 
                setemployeeID,  
                type, 
                setType,
                reportSearch,
                setReportSearch,
                page, setPage,
                limit, setLimit
            }}
        >
            {children}
        </allContext.Provider>
    );
};
